import { state } from '@/store';


export default function meLike(data) {
    let me = false
    for (let index = 0; index < data.length; index++) {
        if (data[index].gpn === state.user.gui) me = true
    }
    if (me) return 'text-warning'
}